import React from "react"

const BackToTop = () => (
  <div id="back-to-top">
    <a className="top" id="top" href="#header-area"> <i className="ti-angle-up"></i> </a>
  </div>
)

export default BackToTop
